import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useFlexItemClassName } from './utils';
import { FLEX_ITEM_CLASS_PREFIX, flexItemRoot } from './constants';
import { FlexItemRoot } from './style';
import { useTheme } from '../../styling';
export var FlexItem = forwardRef(function FlexItem(_ref, ref) {
  var className = _ref.className,
      flexGrow = _ref.flexGrow,
      flexShrink = _ref.flexShrink,
      flexBasis = _ref.flexBasis,
      alignSelf = _ref.alignSelf,
      order = _ref.order,
      restProps = _objectWithoutProperties(_ref, ["className", "flexGrow", "flexShrink", "flexBasis", "alignSelf", "order"]);

  var theme = useTheme().armor;
  var classOverride = useFlexItemClassName(FLEX_ITEM_CLASS_PREFIX, className);
  return React.createElement(FlexItemRoot, Object.assign({
    "data-testid": flexItemRoot
  }, restProps, {
    theme: theme,
    className: classOverride.Root,
    flexGrow: flexGrow,
    flexShrink: flexShrink,
    flexBasis: flexBasis,
    alignSelf: alignSelf,
    order: order,
    ref: ref
  }));
});
FlexItem.defaultProps = {};